<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
              item-value="id_empresa" clearable :label="$tc('company.self', 1)"
              @change="onEmpresaSelectChanged"></v-autocomplete>
          </v-col>
          <!-- adicionar unidade -->
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha 
              :items="unidadesItens"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <!-- termina unidade -->
          <v-col cols="12" sm="6" md="4">
            <v-select v-model="intervalo" :items="intervalosSelect" item-text="text" item-value="value" clearable
              :label="$t('relTripPassangers.interval')"
              :rules="[(v) => !!v || $t('relTripPassangers.rules.obligatoryInterval')]"></v-select>
          </v-col>
          <v-col cols="12" sm="5" md="4">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="5" md="4">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="2" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha" item-value="id_linha"
              clearable multiple :label="$tc('line.self', 1)" @change="linhasSelectChanged"
              :disabled="isLinhaSelectDisabled"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete v-model="idVeiculoSelected" :items="veiculosSelect" item-text="numero_ordem"
              item-value="id_veiculo" clearable multiple :label="$tc('vehicle.self', 1)" @change="veiculosSelectChanged"
              :disabled="isVeiculoSelectDisabled"></v-autocomplete>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="idGuiaSelected"
                :items="guiasSelect"
                item-text="descricao_curta"
                item-value="id_guia"
                clearable
                label="Guia"
                @change="guiasSelectChanged"
              ></v-autocomplete> -->
          <!-- </v-col> -->
        </v-row>
      </v-form>
    </v-container>

      <merus-data-table
        :headers="headersFaixasWithProperties"
        :items="faixasHorarias"
        sort-by="inicio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loadingFaixas"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
    

 cod-tabela="RELPASSAGEIROSVIAGEM__FAIXAS_WITH_PROPERTIES" @update:headers="headersFaixasWithProperties = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relTripPassangers.title')"
                :token="token"
                :items="faixasHorarias"
                csv-title="passageirosporfaixahoraria"
                :pdf-title="$t('relTripPassangers.titleLong')"
                :pdf-headers="headersFaixas"
                :pdf-subtitle="pdfsubtitle"
                pdf-filename="passageirosporfaixahoraria"
                hide-search
            />
        </template>
    </merus-data-table>
  
    <merus-data-table
        :headers="headersViagem"
        :items="viagensFiltered"
        sort-by="inicio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loadingViagens"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
        cod-tabela="RELPASSAGEIROSVIAGEM"
        @update:headers="onHeadersViagemUpdate">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relTripPassangers.title2')"
                :token="token"
                :items="viagensFiltered"
                csv-title="passageirosporviagem"
                :pdf-title="$t('relTripPassangers.title2Long')"
                :pdf-headers="headersPdf"
                :pdf-subtitle="pdfsubtitle"
                pdf-filename="passageirosviagem"
                hide-search
            />
        </template>

      <template v-slot:item.temp_media="{ item }">
        {{ getWeatherTemp(item) }}
      </template>

      <template v-slot:item.condicao_climatica="{ item }">
        <v-icon :color="getWeatherIconColor(item)">{{ getWeatherIcon(item) }}</v-icon>
      </template>

    </merus-data-table>

  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import DateUtils from "../utils/dateutils";
import EventBus from "@/utils/eventBus";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha,
  },
  data: () => ({
    headers: [],
    headersFaixasWithProperties: [],
    search: "",
    user: null,
    token: null,
    mensagemAutorizacaoDialog: "",
    autorizacaoDialog: false,
    showConfirmButton: true,
    formValidado: false,
    loadingViagens: false,
    loadingFaixas: false,
    searchFaixas: "",
    timeProps: {
      useSeconds: true,
    },
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    idGuiaSelected: null,
    idLinhaSelected: [],
    idVeiculoSelected: [],
    empresas: [],
    guias: [],
    guiasSelect: [],
    veiculosSelect: [],
    linhasSelect: [],
    linhas: [],
    unidades: [],
    unidadesSelecionadas: [],
    veiculos: [],
    viagens: [],
    viagensFiltered: [],
    faixasHorarias: [],
    isVeiculoSelectDisabled: false,
    isLinhaSelectDisabled: false,
    config: null,
    intervalo: null
  }),
  computed: {
    /** Fallback quando tabelas_front / headers_tabelas_front não têm RELPASSAGEIROSVIAGEM. */
    headersViagemDefault() {
      return [
        { text: this.$t('relTripPassangers.headers.line'), value: 'cod_linha', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.vehicle'), value: 'numero_ordem_veiculo_realizado', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.start'), value: 'saida_realizada_extenso', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.end'), value: 'chegada_realizada_extenso', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.direction'), value: 'descricao_sentido', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.temperature'), value: 'temp_media', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.climate'), value: 'condicao_climatica', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.paid'), value: 'passageiros_pagantes', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.nonPaid'), value: 'passageiros_gratuidades', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.vt'), value: 'passageiros_vt', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.others'), value: 'passageiros_outros', show: true, sortable: true, filtrable: true },
        { text: this.$t('relTripPassangers.headers.total'), value: 'passageiros_totais', show: true, sortable: true, filtrable: true },
      ];
    },
    headersViagem() {
      return this.headers.length > 0 ? this.headers : this.headersViagemDefault;
    },
    headersPdf() {
      return [
        { text: this.$t('relTripPassangers.headerPdf.vehicle'), value: "numero_ordem_veiculo_realizado" },
        { text: this.$t('relTripPassangers.headerPdf.start'), value: "saida_realizada_extenso" },
        { text: this.$t('relTripPassangers.headerPdf.end'), value: "chegada_realizada_extenso" },
        { text: this.$t('relTripPassangers.headerPdf.direction'), value: "descricao_sentido" },
        { text: this.$t('relTripPassangers.headerPdf.temperature'), value: "temp_media" },
        { text: this.$t('relTripPassangers.headerPdf.climate'), value: "condicao_climatica" },
        { text: this.$t('relTripPassangers.headerPdf.paid'), value: "passageiros_pagantes" },
        { text: this.$t('relTripPassangers.headerPdf.average'), value: "media_pagantes" },
        { text: this.$t('relTripPassangers.headerPdf.nonPaid'), value: "passageiros_gratuidades" },
        { text: this.$t('relTripPassangers.headerPdf.average'), value: "media_gratuidades" },
        { text: this.$t('relTripPassangers.headerPdf.vt'), value: "passageiros_vt" },
        { text: this.$t('relTripPassangers.headerPdf.average'), value: "media_vt" },
        { text: this.$t('relTripPassangers.headerPdf.others'), value: "passageiros_outros" },
        { text: this.$t('relTripPassangers.headerPdf.total'), value: "passageiros_totais" },
        { text: this.$t('relTripPassangers.headerPdf.average'), value: "media_total" }]
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    unidadesItens() {
      return this.unidades;
    },
    intervalosSelect() {
      return [
        { text: this.$t('datetime.hour'), value: "HOUR" },
        { text: this.$t('datetime.day'), value: "DAY" },
        { text: this.$t('datetime.month'), value: "MONTH" },
        { text: this.$t('datetime.year'), value: "YEAR" }]
    },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
    pdfsubtitle() {
      const ordemVeiculo = this.veiculosSelect.filter((veiculo) => { return veiculo.id_veiculo === this.idVeiculoSelected }).map((v) => {
        return v.numero_ordem;
      })

      let subtitle = ""
      if (ordemVeiculo.length > 0) {
        subtitle += `${this.$tc('vehicle.self', 1)}: ${ordemVeiculo} `
      }

      if (this.idGuiaSelected) {
        const nomeGuia = this.guiasSelect.find((guia) => { return guia.id_guia === this.idGuiaSelected }).descricao_curta;
        subtitle += `|  ${this.$tc('guide.self', 1)}: ${nomeGuia}`
      }

      return subtitle;
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.today
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min
      }
    },
    headersFaixas() {
      let h = [
        { text: this.$t('relSubsidy.headersTrip.start'), value: "inicio_extenso" },
        { text: this.$t('relSubsidy.headersTrip.end'), value: "fim_extenso" }
      ]

      if (this.idVeiculoSelected.length > 0) {
        h.push({ text: this.$tc('vehicle.self', 1), value: "numero_ordem" })
      }

      if (this.idLinhaSelected.length > 0) {
        h.push({ text: this.$tc('line.self', 1), value: "cod_linha" })
      }

      h.push({ text: this.$t('relTripPassangers.labelpassangerHour.paid'), value: "passageiros_pagantes" });
      h.push({ text: this.$t('relTripPassangers.labelpassangerHour.nonPaid'), value: "passageiros_gratuidades" });
      h.push({ text: this.$t('relTripPassangers.labelpassangerHour.vt'), value: "passageiros_vt" });
      h.push({ text: this.$t('relTripPassangers.labelpassangerHour.others'), value: "passageiros_outros" });
      h.push({ text: this.$t('relTripPassangers.labelpassangerHour.total'), value: "passageiros_totais" });

        return h
      }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
       }
      },
      unidadesSelecionadas() {
        this.populaVeiculosSelect(this.idEmpresaSelected);
        this.populaLinhasSelect(this.idEmpresaSelected);
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.getConfig();
      this.initialize();
    },
    mounted() {},
    methods: {

      initialize() {
        this.populaEmpresas();
        this.populaVeiculos();
        this.populaUnidades();
        this.populaLinhas();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
          });
        },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          silent: true,
          onSuccess: (response) => {
            this.empresas = response.data;
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          },
        });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        silent: true,
        onSuccess: (response) => {
          this.veiculos = response.data;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaGuias(id_empresa) {
      apiController.request(apiController.endpoints.getGuiasporempresa, {
        params: { id: id_empresa },
        onSuccess: (response) => {
          this.guias = response.data;
          this.populaGuiasSelect();
        },
      });
    },
    populaGuiasSelect() {
      this.guiasSelect = this.guias
        .filter((element) => {
          const dti = DateUtils.getDateSQLFormatted(this.dti);
          const dtf = DateUtils.getDateSQLFormatted(this.dtf);
          const dtguia = DateUtils.getDateSQLFormatted(element.hora_pegada);
          return dti <= dtguia && dtguia <= dtf;
        });
      if (this.idLinhaSelected) {
        this.guiasSelect = this.guiasSelect.filter((g) => g.id_linha === this.idLinhaSelected);
      }
    },
    /**
     * Várias rotas usam aggregatePorUnidades: o objeto vem com `unidades` (array), não `id_unidade`.
     * Linhas de getlinhasporempresa são enriquecidas com `unidades` a partir de getlinhasativas.
     */
    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    onHeadersViagemUpdate(nextHeaders) {
      // Evita zerar colunas se getheaderstabela devolver lista vazia (tabela não cadastrada).
      if (Array.isArray(nextHeaders) && nextHeaders.length > 0) {
        this.headers = nextHeaders;
      }
    },
    populaVeiculosSelect(idempresa) {
      let veiculosFiltrados = [];
      if (idempresa) {
        veiculosFiltrados = this.veiculos.filter((v) => v.id_empresa === idempresa);
      } else {
        veiculosFiltrados = this.veiculos;
      }
      veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
      this.veiculosSelect = veiculosFiltrados;
    },
    /** getlinhasporempresa não traz unidades; copia de this.linhas (getlinhasativas agregado). */
    enriquecerLinhaComUnidades(linhaEmpresa) {
      const ref = (this.linhas || []).find((l) => l.id_linha === linhaEmpresa.id_linha);
      if (ref && Array.isArray(ref.unidades) && ref.unidades.length) {
        return { ...linhaEmpresa, unidades: ref.unidades.slice() };
      }
      return linhaEmpresa;
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data || [];
          this.populaLinhasSelect(this.idEmpresaSelected);
        },
      });
    },
    populaLinhasSelect(id_empresa) {
      if (!id_empresa) {
        let linhasFiltradas = (this.linhas || []).filter((l) => this.passaFiltroUnidades(l));
        this.linhasSelect = linhasFiltradas;
        return;
      }
      apiController.request(apiController.endpoints.getLinhasporempresa, {
        params: { id: id_empresa },
        onSuccess: (response) => {
          let linhasFiltradas = (response.data || []).map((l) => this.enriquecerLinhaComUnidades(l));
          linhasFiltradas = linhasFiltradas.filter((l) => this.passaFiltroUnidades(l));
          this.linhasSelect = linhasFiltradas;
        },
      });
    },
    populaFaixasHorarias() {
      this.loadingFaixas = true;

      let temp = {
        dti: DateUtils.getDateSQLFormatted(this.dti),
        dtf: DateUtils.getDateSQLFormatted(this.dtf),
        intervalo: this.intervalo,
        idveiculos: this.idVeiculoSelected.length > 0 ? this.idVeiculoSelected : null,
        idlinhas: this.idLinhaSelected.length > 0 ? this.idLinhaSelected : null
      }

      apiController.request(apiController.endpoints.getPassageirosporfaixahoraria, {
        data: temp,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados
            .map((f) => this.enriquecerLinhaComUnidades(f))
            .filter((f) => this.passaFiltroUnidades(f));
          this.loadingFaixas = false;
          this.faixasHorarias = dados;
        },
        onError: () => {
          this.loadingFaixas = false;
        },
      });
    },
    populaViagens() {
      this.loadingViagens = true;
      let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
      let idLinhas = this.idLinhaSelected.length > 0
        ? this.idLinhaSelected.slice()
        : this.linhasSelect.map((l) => l.id_linha);
      // Fallback: linhasSelect pode estar vazio (ex.: watcher de unidade sem empresa).
      if (idLinhas.length === 0) {
        idLinhas = (this.linhas || [])
          .filter((l) => this.passaFiltroUnidades(l))
          .map((l) => l.id_linha);
      }
      let temp = {
        id_linha: idLinhas,
        dti: dataInicial,
        dtf: dataFinal
      }

      apiController.request(apiController.endpoints.getPrevistorealizadolinhasdata, {
        data: temp,
        onSuccess: (response) => {
          let dados = (response.data || []).filter((v) => v.passageiros_totais !== null);
          // API devolve só MIN(id_unidade); usa unidades da linha do catálogo.
          dados = dados
            .map((v) => this.enriquecerLinhaComUnidades(v))
            .filter((v) => this.passaFiltroUnidades(v));
          this.viagens = dados;
          this.veiculosSelectChanged();
          this.loadingViagens = false;
        },
        onError: () => {
          this.loadingViagens = false;
        },
      });
    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.viagens = [];
        this.viagensFiltered = [];
        this.populaGuiasSelect();
        this.populaViagens();
        this.populaFaixasHorarias();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    guiasSelectChanged() {
      if (this.idVeiculoSelected.length === 0 && !this.idGuiaSelected) {
        this.viagensFiltered = this.viagens;
        this.isVeiculoSelectDisabled = false;
        this.isLinhaSelectDisabled = false;
      } else if (!this.idGuiaSelected) {
        this.veiculosSelectChanged();
        this.isVeiculoSelectDisabled = false;
        this.isLinhaSelectDisabled = false;
      } else {
        const guia = this.guiasSelect.find((guia) => { return guia.id_guia === this.idGuiaSelected });
        this.idVeiculoSelected.push(guia.id_veiculo);
        this.idLinhaSelected = guia.id_linha;
        this.viagensFiltered = this.viagens.filter((viagem) => {
          return viagem.id_veiculo === guia.id_veiculo &&
            DateUtils.getDateSQLFormatted(viagem.dt_inicio_extenso) >= DateUtils.getDateSQLFormatted(guia.hora_pegada).substring(0, 12) &&
            DateUtils.getDateSQLFormatted(viagem.dt_fim_extenso) <= DateUtils.getDateSQLFormatted(guia.hora_largada).substring(0, 12);
        });
        this.isVeiculoSelectDisabled = true;
        this.isLinhaSelectDisabled = true;
      }
    },
    veiculosSelectChanged() {
      if (this.idVeiculoSelected.length > 0) {
        this.isLinhaSelectDisabled = true;
        this.idLinhaSelected = [];
        this.viagensFiltered = this.viagens.filter((v) => this.idVeiculoSelected.includes(v.id_veiculo));
      } else {
        this.isLinhaSelectDisabled = false;
        this.viagensFiltered = this.viagens;
      }
    },
    linhasSelectChanged() {
      if (this.idLinhaSelected.length > 0) {
        this.isVeiculoSelectDisabled = true;
        this.idVeiculoSelected = [];
      } else {
        this.isVeiculoSelectDisabled = false;
      }
    },
    onEmpresaSelectChanged() {
      this.populaLinhasSelect(this.idEmpresaSelected);
      this.populaVeiculosSelect(this.idEmpresaSelected);
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
        },
      });
    },
    onDateChanged() {
      this.populaGuiasSelect();
    },
    getWeatherIcon(item) {
      if (!item.condicao_climatica) {
        return null;
      }
      return item.condicao_climatica === this.$t('relTimePlate.rain') ? "mdi-weather-rainy" : "mdi-weather-sunny"
    },
    getWeatherIconColor(item) {
      if (!item.condicao_climatica) {
        return null;
      }
      return item.condicao_climatica === this.$t('relTimePlate.rain') ? "blue" : "orange"
    },
    getWeatherTemp(item) {
      if (!item.temp_media) {
        return null;
      }
      return `${item.temp_media} °C`;
    }
  },
};
</script>